<template>
  <div class='page-wrap' :class='device=="mobile"?"mobile":""'>
    <nav-bar></nav-bar>
    <div class="app-container" v-loading='pageLoading'>
      <div class='theader'>
        <p>交易详情</p>
      </div>
      <div class="page-sec">
        <template v-if='info'>
          <div class="content-sec">
            <div class="common-row"><span class='key'>交易哈希：</span><span class='value'>{{ hash }}</span><span class="copy-btn" :data-clipboard-text="hash" @click='copyFn'></span></div>
            <div class="common-row"><span class='key'>交易时间：</span><span class='value'>{{ info.transactionTime }}</span></div>
            <div class="common-row"><span class='key'>发送账户：</span><span class='value link-type' @click='transAddr(info.fromAddress)'>{{ info.fromAddress }}</span></div>
            <div class="common-row"><span class='key'>接收账户：</span><span class='value link-type' @click='transAddr(info.toAddress)'>{{ info.toAddress }}</span></div>
          </div>
          <div class="content-sec">
            <div class="common-row"><span class='key'>区块高度：</span><span class='value link-type' @click='$router.push({ name: "block", query: { key: info.inLedger } })'>{{ info.inLedger }}</span></div>
            <div class="common-row"><span class='key'>区块生成时间：</span><span class='value'>{{ info.indate }}</span></div>
            <div class="common-row">
              <span class='key'>交易状态：</span>
              <span class='value' :class='info.transactioState===0?"text-gray":info.transactioState===1?"text-green":""'>{{ info.transactioState===0?"等待确认":info.transactioState===1?"交易成功":"" }}</span>
            </div>
          </div>
          <div class="content-sec">
            <div class="common-row"><span class='key'>主资产编号：</span><span class='value link-type' @click='$router.push({ name: "assets", query: { key: info.mainId } })'>{{ info.mainId }}</span></div>
            <div class="common-row"><span class='key'>子资产编号：</span><span class='value'>{{ info.subId }}</span></div>
            <div class="common-row"><span class='key'>交易订单号：</span><span class='value'>{{ info.transactionOrderId }}</span></div>
          </div>
        </template>
        <el-row v-else type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>

      <div class='theader'>
        <p>资产信息</p>
      </div>
      <div v-if='info' class="page-sec flex">
        <el-image
          v-if='info.subPicUrl || info.coverPicUrlBase64'
          class='col-image'
          :src="info.subPicUrl || ('data:image/jpeg;base64,' + info.coverPicUrlBase64)"
          @error="errorFn"
          fit="contain">
        </el-image>
        <div class='content-sec'>
          <div class="common-row"><span class='key'>作品名称：</span><span class='value'>{{ info.productName }}</span></div>
          <div class="common-row"><span class='key'>作者名称：</span><span class='value'>{{ info.authorNames.join('，') }}</span></div>
          <div class="common-row"><span class='key'>发行时间：</span><span class='value'>{{ info.releaseTime }}</span></div>
          <div class="common-row"><span class='key'>发行账户：</span><span class='value link-type' @click='transAddr(info.fromAddress)'>{{ info.fromAddress }}</span></div>
          <div class="common-row"><span class='key'>持有账户：</span><span class='value link-type' @click='transAddr(info.toAddress)'>{{ info.toAddress }}</span></div>
        </div>
      </div>
      <div v-else class="page-sec">
        <el-row type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>
    </div>
    
  </div>
</template>

<script>
import { main } from '@/api/trade'
import { Mixin } from '@/utils/mixin.js'

export default {
  name: 'trade',
  mixins: [ Mixin ],
  data() {
    return {
      hash: this.$route.query.key,
      // 08648DC32034076967E87F6FEAFF54BC9B1E45CE768F184D16E45F5976C4D4F2
      info: null,
      tableKey: 0,
      list: null,
      total: null,
      pageLoading: false,
      listLoading: true,
      freshLoading: false,
      buttonDisabled: true,
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.pageLoading = true
      main({
        TransactionHash: this.hash
      }).then(response => {
        this.pageLoading = false
        this.info = response.data
        // this.list = responses[1].data.items
        // this.total = responses[1].data.totalCount
        // this.pageLoading = false
        // this.$nextTick(()=>{
        //   this.$refs.table.doLayout()
        // })
      }).catch(() => {
        this.pageLoading = false
      })
    },
    errorFn() {
      this.$message('资产图片在上链的路上，请稍后再次查询')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">

  
</style>
